import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import * as fromWorkspace from 'src/store/workspace';
import * as fromRoot from 'src/store/index';
import {
  Store
} from '@ngrx/store';
import {
  Observable,
  Subscription,
  combineLatest
} from 'rxjs';
import {
  StaffDTO,
  TimeSummaryRow,
  View,
  Message,
  PTO
} from 'src/store/workspace';
import * as moment from 'moment';
import {
  SortDescriptor
} from '@progress/kendo-data-query';
import {
  getClass
} from '../alert/alert.component';
import { PagerSettings, PageChangeEvent } from '@progress/kendo-angular-grid';
import { isNumber } from 'lodash';

@Component({
  selector: 'app-timesheet-summary',
  templateUrl: './timesheet-summary.component.html',
  styleUrls: ['./timesheet-summary.component.scss']
})
export class TimesheetSummaryComponent {
  staff$: Observable < StaffDTO > ;

  searchStaff$: Observable<StaffDTO>;
  searchStaffSubs: Subscription;
  searchStaff: StaffDTO;

  gridData$: Observable < [TimeSummaryRow[], any] > ;
  gridDataSubs: Subscription;
  gridData: TimeSummaryRow[];
  hours$: Observable < number > ;
  unsubmittedHours$: Observable < number > ;
  clientsCount$: Observable < number > ;
  public columns: any[] = [{
      field: 'id',
      hidden: true
    },
    {
      field: 'staffName',
      title: 'Staff',
    },
    {
      field: 'payPeriodStarting',
      title: 'Start Date',
      format: 'd'
    },
    {
      field: 'payPeriodEnding',
      title: 'End Date',
      format: 'd'
    },
    {
      field: 'hoursBillable',
      title: 'Hours Worked',
      format: 'n'
    },
    {
      field: 'clientName',
      title: 'Client'
    },
    {
      field: 'submittedDate',
      title: 'Submitted on',
      format: 'd'
    },
  ];

  public pageSize: number | 'all' = 'all';
  public skip = 0;
  public length: number;
  public pageable: PagerSettings = {
    pageSizes: true,
    previousNext: true,
    info: true
  };
  public pageSizes: any[] = [10, 20, 30, 40, 50, {
    text: 'All',
    value: 'all'
  }];

  public multiple = true;
  public allowUnsort = true;
  public sort: SortDescriptor[];
  public sort$: Observable < SortDescriptor[] > ;
  public sortable = {
    allowUnsort: this.allowUnsort,
    mode: this.multiple ? 'multiple' : 'single'
  };

  alert$: Observable < Message > ;
  getClass = getClass;

  constructor(private store: Store < fromRoot.AppState > , private cdr: ChangeDetectorRef) {
    this.store.dispatch(new fromWorkspace.LoadSummariesPageSize());
    this.alert$ = this.store.select(state => state.workspace.alert);
    this.staff$ = this.store.select(state => state.workspace.staff);
    this.searchStaff$ = this.store.select(state => state.workspace.searchByOptions.staff);
    this.searchStaffSubs = this.searchStaff$.subscribe(staff => {
      this.searchStaff = staff;
      if (staff && !staff.staffID) {
        this.columns[1].hidden = false;
      } else {
        this.columns[1].hidden = true;
      }
    });

    this.gridData$ = combineLatest(
      this.store.select(fromWorkspace.selectSummaryRowsForGrid),
      this.store.select(state => state.workspace.summaryPageSize),
    );
    this.gridDataSubs = this.gridData$.subscribe(([data, pageSize]) => {
      this.length = data.length;
      this.pageSize = pageSize;
      if (!isNumber(pageSize) && this.length) {
        this.pageSize = this.length || 10;
      }
      const size = this.pageSize as number;
      this.gridData = data.slice(this.skip, this.skip + size);
    });
    this.store.dispatch(new fromWorkspace.LoadSummariesPageSize());
    this.store.select(state => state.workspace.summaryPageSize).subscribe(size => {
      this.pageSize = size;
    });
    this.hours$ = this.store.select(state => state.workspace.totalHoursInSheet);
    this.unsubmittedHours$ = this.store.select(state => state.workspace.totalHoursUnsubmitted);
    this.clientsCount$ = this.store.select(state => state.workspace.numberOfClientsInSheet);

    this.sort$ = this.store.select(state => state.workspace.summarySort);
    this.sort$.subscribe(sort => this.sort = sort);
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    let pageSize: number | 'all' = event.take;
    if (pageSize === this.length) {
      pageSize = 'all';
    }

    this.store.dispatch(new fromWorkspace.SetSummariesPageSize(pageSize));
    this.store.dispatch(new fromWorkspace.LoadSummaries());
  }

  toggleView() {
    this.store.dispatch(new fromWorkspace.SetUnsubmittedSummaryRows([]));
    this.store.dispatch(new fromWorkspace.LoadTimesheets());
    this.store.dispatch(new fromWorkspace.SetView(View.detail));
  }

  getSubmittedDate(row: TimeSummaryRow): string {
    if (moment(row.submittedDate).isAfter(moment('0001-01-01T00:00:00'))) {
      return moment(row.submittedDate).format('MM/DD/YYYY h:mm a');
    }
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.store.dispatch(new fromWorkspace.SetSort({
      sort,
      view: View.summary
    }));
  }

  submit(row: TimeSummaryRow) {
    this.store.dispatch(new fromWorkspace.SetLoading(true));
    if (row.timeSummaryIdx) {
      this.store.dispatch(new fromWorkspace.UndoSummaryRow(row.timeSummaryIdx));
    } else {
      this.store.dispatch(new fromWorkspace.SubmitSummaryRow(row));
    }
    this.cdr.detectChanges();
  }
}
